import { CustomSelectShadcn } from "../../components/custom-select-shadcn.component";
import { SelectProps } from "../../forms/form-types";
import { useCatalogsStore } from "../../store/Catalogs";
import { useEffect } from "react";

interface CatalogSelectProps extends SelectProps {
	helperText?: string;
	emptyLabel?: string;
	showEmpty?: boolean;
}

export const CatalogSelect: React.FC<CatalogSelectProps> = ({
	emptyLabel = "Labor-Standard",
	showEmpty = true,
	...props
}) => {
	const { catalogs, loadCatalogs } = useCatalogsStore((state) => ({
		catalogs: state.catalogs,
		loadCatalogs: state.loadCatalogs,
	}));

	useEffect(() => {
		if (catalogs.length === 0) {
			loadCatalogs();
		}
	}, [catalogs.length, loadCatalogs]);

	const activeCatalogs = catalogs
		.filter(catalog => !catalog.is_deactivated)
		.sort((a, b) => {
			if (a.catalog_type === b.catalog_type) {
				return a.name?.localeCompare(b.name || '') || 0;
			}
			return a.catalog_type === 'custom' ? -1 : 1;
		});

	const options = [
		...(showEmpty ? [{ value: "", label: emptyLabel }] : []),
		...activeCatalogs.map(catalog => ({
			value: catalog.id as string,
			label: `${catalog.name}${catalog.catalog_type === 'custom' ? ' (Eigener Tarifkatalog)' : ''}`,
		}))
	];

	return (
		<CustomSelectShadcn
			options={options}
			inputLabel="Standard-Tarifkatalog"
			value={props.value || ""}
			onChange={(value) => {
				props.onChange(value?.toString() || null);
			}}
			disabled={props.disabled}
			width={props.width}
			required={props.required}
			helperText={props.helperText}
		/>
	);
};
